module.exports = __webpack_public_path__ + "static/media/1POLICY32.441c1c3b.jpg";